import { Box } from "./Box";
import { BoxProps } from "./types";

export const Stack = ({children, gap = '8px', ...props}:BoxProps) => {
    return <Box className="d-flex flex-column" gap={gap} {...props}>
        {children}
    </Box>
}